export default function ({ route, redirect }) {
  // Редирект с /postcards на статический HTML
  if (route.path === '/postcards' || route.path === '/postcards/') {
    return redirect(301, '/postcards/')
  }
}

